class FeaturedFilter extends HTMLElement {
  constructor() {
    super();
    let triggers = this.querySelectorAll(".tab");

    function clearActiveTab(f) {
      f.forEach((t) => {
        t.classList.remove("active");
      });
    }

    triggers.forEach((t) => {
      t.addEventListener("click", (e) => {
        clearActiveTab(triggers);
        t.classList.add("active");
        this.setAttribute("data-active", e.target.innerText);
      });
    });
  }

  static get observedAttributes() {
    return ["data-active"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    let dataCat = this.getAttribute("data-active");

    if (name == "data-active") {
      this.filterByCat(dataCat);
    }
  }

  filterByCat(d) {
    const holdingPen = document.querySelector(".slide-holding-pen");
    const slides = holdingPen.innerHTML;
    const slidesContainer = document.querySelector(
      ".embla-featured-products .embla__container",
    );
    slidesContainer.innerHTML += slides;
    holdingPen.innerHTML = "";
    if (
      d == "Alle" ||
      d == "All" ||
      d == "All Articles" ||
      d == "All Products"
    ) {
      document.querySelectorAll(".has-filters .filter_item").forEach((i) => {
        // i.classList.remove("visually-hidden");
      });
    } else {
      document.querySelectorAll(".has-filters .filter_item").forEach((c, i) => {
        if (c.dataset.cats.includes(d) || c.dataset.cats == d) {
          c.classList.remove("visually-hidden");
        } else {
          holdingPen.innerHTML += c.outerHTML;
          c.remove();
        }
      });
    }
  }
}

customElements.define("featured-filters", FeaturedFilter);

// Filter Dropdown Mobile

function filterDropdown() {
  const catFilter = document.querySelector(".tabs");
  const maxWidth = window.matchMedia("(max-width: 749px)");

  catFilter.addEventListener("click", function (event) {
    if (maxWidth.matches) {
      if (this.classList.contains("tabs-active")) {
        // this.classList.remove("tabs-active");
      } else {
        openFilter(event, this);
      }
    }
  });

  function openFilter(event, filter) {
    event.preventDefault();
    filter.classList.add("tabs-active");
  }
}

if (document.querySelector(".tabs")) {
  filterDropdown();
}
